import { Component, OnInit, Input } from '@angular/core';
@Component({
  selector: 'app-right-column',
  templateUrl: './rightcolumn.component.html',
  styles: [``]
})
export class RightcolumnComponent {
}
